import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Path,
  Svg
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(Path, { d: "M4 4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h16", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M2 14h12", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M22 14h-2", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M12 20v-6", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "m2 2 20 20", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M22 16V6a2 2 0 0 0-2-2H10", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "TouchpadOff";
const TouchpadOff = memo(themed(Icon));
export {
  TouchpadOff
};
//# sourceMappingURL=touchpad-off.js.map
